module.exports = "<chat-users [users]=\"users\"></chat-users>\r\n<chat-body [messages]=\"messages\"></chat-body>\r\n<chat-form></chat-form>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/shared/chat/chat/chat.component.html
// module id = ../../../../../src/app/shared/chat/chat/chat.component.html
// module chunks = main